export enum FlowStep {
  Preselection = 1,
  Calendar = 2,
  PatientData = 3,
  Verification = 4,
  Success = 5
}
